export  const mapMenu = {
    Guangzhou:"广州",
    Shenzhen:"深圳",
    Dongguan:"东莞",
    Foshan:"佛山",
    Zhongshan:"潮州",
    Zhuhai:"珠海",
    Shantou:"汕头",
    Jiangmen:"江门",
    Zhanjiang:"湛江",
    Shaoguan:"韶关",
    Qingyuan:"清远",
    Chaozhou:"潮州",
    Jieyang:"揭阳",
    Maoming:"茂名",
    Zhaoqing:"肇庆",
    Huizhou:"惠州",
    Meizhou:"梅州",
    Shanwei:"汕",
    Yangjiang:"阳江",
    Heyuan:"河源",
    Yunfu:"云浮"
}

